import { message, Tree } from 'antd';
import lodash from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import moment from 'moment';
import api from './api';
import getStatusName from './getStatusName';
import gmrfidCode from './gmrfidCode';
import request from './request';
import request1 from './request1';

// 防抖
export function reDebounce(fn, wait = 500) {
  let timer: ReturnType<typeof setTimeout> | null = null;
  return e => {
    clearTimeout(timer as ReturnType<typeof setTimeout>);
    timer = setTimeout(() => {
      fn(e);
    }, wait);
  };
}

/**
 * 根据证件类型验证证件号码的格式
 * @param {string} idType - 证件类型，例如 '身份证' 或 '护照'
 * @param {boolean} desensitize - 是否进行脱敏处理
 * @return {RegExp} 返回对应证件类型的正则表达式对象
 */

const idTypeRegs = {
  ID_CARD: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}(\d|X)$/, // 身份证
  PASSPORT: /^[A-Z]{1,2}\d{6,9}$/, // 护照
  OTHER: /.$/, // 其他
  HK_MACAO_TAIWAN_EEP: /^(?:[HM]{1}[0-9]{8}|[0-9]{8}(?:[Tt][A-Za-z])?)$/, // 港澳台通行证
  PLACE_ID_CARD: /.$/, // 警官证
  OFFICERS_CERTIFICATE: /.$/, // 军官证
  BUSINESS_LICENSE: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/, // 营业执照
};

function validateIdNumber(idType, desensitize = false) {
  const regex = idTypeRegs[idType];
  return new RegExp(regex);
}

/* * 时间格式化工具
 * 把Long类型的1527672756454日期还原yyyy-MM-dd格式日期
 */
function datetimeFormat(longTypeDate) {
  let dateTypeDate = '';
  const date = new Date();
  date.setTime(longTypeDate);
  dateTypeDate += date.getFullYear(); // 年
  dateTypeDate += `-${getMonth(date)}`; // 月
  dateTypeDate += `-${getDay(date)}`; // 日
  return dateTypeDate;
}

// 返回 01-12 的月份值
function getMonth(date) {
  let month = '';
  month = date.getMonth() + 1; // getMonth()得到的月份是0-11
  if (month < 10) {
    month = `0${month}`;
  }
  return month;
}

// 返回01-30的日期
function getDay(date) {
  let day = '';
  day = date.getDate();
  if (day < 10) {
    day = `0${day}`;
  }
  return day;
}

// 毫秒数转换为天数
function getDuration(my_time) {
  const days = my_time / 1000 / 60 / 60 / 24;
  const daysRound = Math.floor(days);
  return daysRound;
}

// 定义系统用户名和密码
const systemInfo = {
  username: 'Troy',
  password: '111111',
};
const { TreeNode } = Tree;

/**
 * 数组格式转树状结构
 * @param   {array}     array
 * @param   {String}    id
 * @param   {String}    pid
 * @param   {String}    children
 * @return  {Array}
 */
const arrayToTree = (
  array = [],
  id = 'id',
  pid = 'pid',
  children = 'children',
) => {
  if (!Array.isArray(array)) {
    return [];
  }
  const data = lodash.cloneDeep(array);
  const result = [];
  const hash = {};
  data.forEach((item, index) => {
    hash[data[index][id]] = data[index];
  });
  data.forEach((item) => {
    const hashVP = hash[item[pid]];
    if (hashVP) {
      !hashVP[children] && (hashVP[children] = []);
      hashVP[children].push(item);
    } else {
      result.push(item);
    }
  });
  return result;
};
/**
 * 树形节点生成
 * @param {Array} treeData
 * @param {String} key
 * @param {String} pId
 * @param {String} name
 */
const arrayToNodes = (treeData, name = 'name') =>
  treeData.map((item) => {
    if (item.children && item.children.length) {
      return (
        <TreeNode key={item.id} title={item[name]} {...item}>
          {arrayToNodes(item.children, name)}
        </TreeNode>
      );
    }
    return <TreeNode key={item.id} title={item[name]} {...item} />;
  });

/**
 *  替换对象属性名称
 * @ param {array} data
 */
const changeKeyNamesChildren = (arry, namesMap) => {
  return arry.map((item) => {
    const temp = { ...item };
    if (item.children) {
      temp.children = item.children.map((k) => {
        const _temp = { ...k };
        Object.keys(namesMap).forEach((key) => {
          _temp[key] = _temp[namesMap[key]];
        });
        return _temp;
      });
    }
    Object.keys(namesMap).forEach((key) => {
      temp[key] = temp[namesMap[key]];
    });

    return temp;
  });
};

/**
 *  替换对象属性名称
 * @ param {array} data
 */
const changeKeyNames = (arry, namesMap) => {
  let arryData = [];
  if (!Array.isArray(arry) || arry.length === 0) {
    return arryData;
  }
  arryData = arry.map((item) => {
    const temp = { ...item };
    Object.keys(namesMap).forEach((key) => {
      temp[key] = temp[namesMap[key]];
    });
    if (item.children && item.children.length) {
      temp.children = changeKeyNames(temp.children, namesMap);
    }
    return temp;
  });
  return arryData;
};

/*
图片尺寸
*/
function getFileWidthAndHeight(file, w, h) {
  return new Promise((res, rej) => {
    const _URL = window.URL || window.webkitURL;
    const img = new Image();
    img.onload = function () {
      if (img.width > w || img.height > h) {
        message.error(`请上传图片尺寸为${w}*${h}`);
        res(false);
      } else if (img.width <= w && img.height <= h) {
        res(true);
      }
    };
    img.src = _URL.createObjectURL(file);
  });
}

/*
树级解构
*/
function treeDeconstruction(data) {
  const arryData = [];

  function opt(arry) {
    if (!Array.isArray(arry) || arry.length === 0) {
      return arryData;
    }
    arry.map((item) => {
      arryData.push(item);
      if (item.children && item.children.length) {
        item.children = opt(item.children);
      }
    });
  }

  opt(data);
  return arryData;
}

/**
 合并children
 */
function sceneFilterFn(_arr, key) {
  const map = {};
  const dest = [];
  for (let i = 0; i < _arr.length; i++) {
    const ai = _arr[i];
    if (!map[ai[key]]) {
      dest.push({
        children: [ai],
        compName: ai[key],
        title: ai.deptName,
        id: ai.deptId,
        key: ai.deptId,
        value: ai.deptId,
        disabled: true,
      });
      map[ai[key]] = ai;
    } else {
      for (let j = 0; j < dest.length; j++) {
        const dj = dest[j];
        if (dj.compName == ai[key]) {
          dj.children.push(ai);
          break;
        }
      }
    }
  }
  return dest;
}

/**
 * hook 性能优化
 */
const useSyncCallback = (callback) => {
  const [proxyState, setProxyState] = useState({ current: false });

  const Func = useCallback(() => {
    setProxyState({ current: true });
  }, [proxyState]);

  useEffect(() => {
    if (proxyState.current === true) setProxyState({ current: false });
  }, [proxyState]);

  useEffect(() => {
    proxyState.current && callback();
  });

  return Func;
};

/*
 根据id 查父级id
*/
function getParentIds(id, data) {
  // 深度遍历查找
  function dfs(data, id, parents) {
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      // 找到id则返回父级id
      if (item.id === id || item.parentId === id) return parents;
      // children不存 在或为空则不递归
      if (!item.children || !item.children.length) continue;
      // 往下查找时将当前id入栈
      // parents.push(item.id, {
      //   name: item.name,
      //   uri: item.uri,
      //   id: item.id,
      //   icon: item.icon,
      //   parentId: item.parentId
      // })

      parents.push({
        name: item.name,
        uri: item.uri,
        id: item.id,
        icon: item.icon,
        parentId: item.parentId,
      });
      if (dfs(item.children, id, parents).length) return parents;
      // 深度遍历查找未找到时当前id出栈
      parents.pop();
    }
    // 未找到时返回空数组
    return [];
  }

  return dfs(data, id, []);
}

/* 计时器 */
function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

/*
 *键盘事件
 *useOnKeyDown(fn,opt={})
 *
 */
function useOnKeyDown(callback, opt) {
  const savedCallback = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    document.onkeydown = function (event) {
      const e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode === 13) {
        callback(opt);
      }
    };
  });
}

/* 图片地址 */
const imgUrlHandle = (str) => {
  const http = sessionStorage.getItem('httpUrl') || 'https://images.jmhvip.com';
  if (str && str.includes('*')) {
    return str;
  }
  return (str && str.includes('http')) || (str && str.includes('https')) ? str : `${http}/${str}`;
};


/* 下载 */
const fileDownLoad = (res) => {
  const { data, headers } = res;
  const fileName = headers['content-disposition'].split(
    'attachment;filename=',
  )[1];
  const blob = new Blob([data]);
  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.download = decodeURI(fileName);
  a.href = blobUrl;
  document.body.appendChild(a);
  a.click();
  a.parentNode.removeChild(a);
  window.URL.revokeObjectURL(blobUrl);
};

/* 模糊查询 */
const filterTree = (value, arr, key = 'name', isTree = false) => {
  const newArr = [];
  arr.forEach((element) => {
    if (element[key].indexOf(value) > -1) {
      newArr.push(element);
    } else if (element.children && element.children.length > 0) {
      const item = filterTree(value, element.children);
      if (item && item.length > 0) {
        /* 返回树状 */
        if (isTree) {
          const obj = {
            ...element,
            children: item,
          };
          newArr.push(obj);
        } else {
          item.forEach((sonItem) => {
            if (sonItem[key].indexOf(value) > -1) {
              newArr.push(sonItem);
            }
          });
        }
      }
    }
  });
  return newArr;
};

/* 获取当月所有日期 */
/*
 * date:日期
 *
 * boolean:是否补齐首尾日期
 *
 * */
const getMonthAllDate = (date, boolean) => {
  let arr = [];
  const dayNum = moment(date).daysInMonth();
  const monthStart = moment(date)
    .startOf('month')
    .format('YYYY-MM-DD');
  const monthEnd = moment(date)
    .endOf('month')
    .format('YYYY-MM-DD');
  if (boolean) {
    if (moment(monthStart).day() !== 1) {
      for (let i = 0; i < (moment(monthStart).day() === 0 ? 6 : moment(monthStart).day() - 1); i++) {
        const newDate = moment(monthStart).subtract(
          moment(monthStart).day() === 0 ? 6 - i : moment(monthStart).day() - 1 - i,
          'days',
        );
        arr.push({
          date: newDate.format('YYYY-MM-DD'),
          day: newDate.format('D'),
          week: newDate.day(),
        });
      }
    }
    for (let i = 0; i < dayNum; i++) {
      const newDate = moment(monthStart).add(i, 'days');
      arr.push({
        date: newDate.format('YYYY-MM-DD'),
        day: newDate.format('D'),
        week: newDate.day(),
      });
    }
    // if (moment(monthEnd).day() !== 0) {
    //   for (let i = 0; i < 7 - moment(monthEnd).day(); i++) {
    //     const newDate = moment(monthEnd).add(i + 1, 'days')
    //     arr.push({
    //       date: newDate.format('YYYY-MM-DD'),
    //       day: newDate.format('D'),
    //       week: newDate.day()
    //     })
    //   }
    // }
  } else {
    for (let i = 0; i < dayNum; i++) {
      const newDate = moment(monthStart).add(i, 'days');
      arr.push({
        date: newDate.format('YYYY-MM-DD'),
        day: newDate.format('D'),
        week: newDate.day(),
      });
    }
  }
  const endNum = 42 - arr.length;

  for (let i = 0; i < endNum; i++) {
    const newDate = moment(monthEnd).add(i + 1, 'days');
    arr.push({
      date: newDate.format('YYYY-MM-DD'),
      day: newDate.format('D'),
      week: newDate.day(),
    });
  }

  arr = arr.sort((a, b) => {
    if (moment(a.date).format('x') > moment(b.date).format('x')) {
      return 1;
    }
    return -1;
  });

  return arr;
};
export {
  validateIdNumber,
  datetimeFormat,
  getDuration,
  getMonthAllDate,
  systemInfo,
  request,
  request1,
  useInterval,
  useOnKeyDown,
  api,
  arrayToTree,
  arrayToNodes,
  changeKeyNames,
  changeKeyNamesChildren,
  getFileWidthAndHeight,
  getStatusName,
  gmrfidCode,
  treeDeconstruction,
  sceneFilterFn,
  useSyncCallback,
  getParentIds,
  imgUrlHandle,
  fileDownLoad,
  filterTree,
};
